module.exports = __webpack_public_path__ + "img/head-bg.c8ecfc35.png";